<template>
  <div id="wrapper">
    <Header :isLogin="isLogin" />
    <router-view />
    <Footer :isLogin="isLogin" :userPid="userPid" />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import firebase from "firebase";

export default {
  name: "Home",
  data() {
    return {
      isLogin: false,
      db: firebase.firestore(),
      userPid: undefined,
    };
  },
  components: {
    Header,
    Footer,
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      this.isLogin = user !== null && user.phoneNumber !== null;
      if (user !== null) {
        this.db
          .collection("users")
          .doc(user.uid)
          .get()
          .then((doc) => {
            if (doc.exists) {
              const data = doc.data();
              this.userPid = data.pid;
            }
          });
      }
    });
  },
};
</script>

<style>
@import "./assets/css/basic.css";
@import "./assets/css/common.css";
@import "./assets/css/sanitize.css";
@import "./assets/css/structure.css";
</style>
